import {React, useEffect} from "react";
import HeroHeader from "./HeroHeader";
import ContactCTA from "./ContactCTA";
import { Helmet } from "react-helmet";
import Cover from "../img/Robotics_cover.png";
import Arm1 from "../video/cyberpunk_turnaround.mp4";
import Arm2 from "../video/steampunk_turnaround.mp4";
import Sketches from "../img/robotjournal_sketches.png";
import Arm1Closeup1 from "../img/prosthesis1_closeup.jpg";
import Arm1Closeup2 from "../img/prosthesis1_closeup2.jpg";
import Arm2Closeup1 from "../img/prosthesis2_closeup.jpg";
import Arm2Closeup2 from "../img/prosthesis2_closeup2.jpg";
import CoverAnim from "../video/prosthetics_anim_cover.mp4";



function SciRobotics() {


  // useEffect(() => {
  //   document.title = "ETCHNG | Promoting the role of competition-driven robotics in rehabilition research";

  // }, []);
  return (
    <>

      <Helmet>
        <title>ETCHNG | Promoting the role of competition-driven robotics in rehabilition research</title>
        <meta name="description" content="Promoting the role of competition-driven robotics in rehabilition research" />
        <meta name="keywords" content=" ETCHNG, 3D,rehabilitation, robotics" /> </Helmet>
      <HeroHeader
        hero_img={Cover}
        type="Editorial cover —"
        name="Promoting the role of competition-driven robotics in rehabilition research"
       
      />

      <div className="wrapper">
        <div className="wrapper__inner">
          <div className="work">
            <div className="work__info twoColumn">
              <div className="work__info__basic">
              <div className='work__info__basic__item'> <h5>Date</h5>
                  <p>Nov 2020 </p> </div>
                  <div className='work__info__basic__item'>    <h5>Role</h5>
                  <p>3D artist</p></div>
                  <div className='work__info__basic__item'> <h5>Tools</h5>
                  <p>Maya, Blender, ZBrush</p></div>
              </div>
            </div>

            <div className="work__info twoColumn">
              <h4>INTRODUCTION</h4>
              <p>
              Current assistive technologies tend to lack functionality and usability, leading to poor acceptance and insufficient support during daily activities. Cybathlon was thus established to promote the research and innovation of such devices. It includes a science symposium followed by a competition for contestants with motor impairments who compete in disciplines based on device technology and use case.           </p>

            
            </div>

            
          </div>
 



          <div  className="work">

<div  className="work__info twoColumn">
  <h4>CHALLENGE</h4>


</div>
<div  className="work__info twoColumn">

  <p>
    This concept cover's goal was to create a visual metaphor that promoted the Cybathlon event.

  </p>




</div>

</div>

<div  className="work">
<div  className="work__info">
  <h4>PROCESS</h4>

</div>

</div>
<div  className="work">

<div  className="work__info narrowColumn">

  <p>
    Initial thumbnail sketches were done of potential cover compositions. Many of these initially experimented
    with a dichotemy of the prosthesis being used in a high-perfomance context, versus in a mundane task.
  </p>


</div>
<div  className="work__info wideColumn">
  <img src={Sketches} loading="lazy" alt="Thumbnail sketches.">
  </img>


</div>

</div>






<div  className="work">
<div  className="work__info wideColumn">
  <img src={Arm1Closeup1} loading="lazy" alt="Closeup of a prosthesis.">
  </img>

</div>
<div  className="work__info narrowColumn">

  <p>
    These are closeups and turnaround models of the arms. This one was intentionally designed to have a more
    delicate aesthetic, emulating ceramics.
  </p>
  <img src={Arm1Closeup2} loading="lazy" alt="Closeup of a prosthesis.">
</img>

</div>

</div>

<div  className="work">
<div  className="work__info twoColumn">
  <video loop controls autoplay width="100%" height="540">
    <source src={Arm2} loading="lazy" type="video/mp4"/>
    Your browser does not support the video tag.
  </video>
</div>
<div  className="work__info twoColumn">
  <video loop controls autoplay width="100%" height="540">
    <source src={Arm1} loading="lazy" type="video/mp4"/>
    Your browser does not support the video tag.
  </video>
</div>
</div>


<div  className="work">
<div  className="work__info narrowColumn">

  <p>
    This arm was patterned aftern mech suits, and was intentionally much more aggressive and bulky.
  </p>
  <img src={Arm2Closeup2} loading="lazy" alt="Closeup of a prosthesis.">
</img>

</div>

<div  className="work__info wideColumn">
  <img src={Arm2Closeup1} loading="lazy" alt="Closeup of a prosthesis.">
  </img>

</div>


</div>





<div  className="work" >

<div  className="work__info wideColumn">

<img src={Cover} loading="lazy"
alt="Skull of Homo erectus pekinensis with tissue depth markers">
</img>

</div>

<div  className="work__info narrowColumn">
<p>This is the final cover. I also quickly mocked up an accompanying animated version for fun.</p>

<video loop controls autoplay width="100%" height="540">
  <source src={CoverAnim} loading="lazy" type="video/mp4"/>
  Your browser does not support the video tag.
</video>
</div>

</div>
           

        </div>

        <ContactCTA />
      </div>
    </>
  );
}

export default SciRobotics;
